import { useModal } from "../contexts/ModalContext";
import Login from "./Login";
import UserProfile from "./UserProfile";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import EventDetails from "./EventDetails";
import CustomAlert from "./CustomAlert";
import Checkout from "./Checkout";
import FindStuff from "./FindStuff";
import EditPreference from "./EditPreference";

const ModalManager = () => {

    const { isModalOpen, closeModal, getModalProps } = useModal();

    return (
        <>
            {isModalOpen("alert") && <CustomAlert handleClose={() => closeModal("alert")} {...getModalProps("alert")} />}
            {isModalOpen("login") && <Login handleClose={() => closeModal("login")} {...getModalProps("login")} />}
            {isModalOpen("profile") && <UserProfile handleClose={() => closeModal("profile")} {...getModalProps("profile")} />}
            {isModalOpen("register") && <Register handleClose={() => closeModal("register")} {...getModalProps("register")} />}
            {isModalOpen("forgot") && <ForgotPassword handleClose={() => closeModal("forgot")} {...getModalProps("forgot")} />}
            {isModalOpen("event") && <EventDetails handleClose={() => closeModal("event")} {...getModalProps("event")} />}
            {isModalOpen("checkout") && <Checkout handleClose={() => closeModal("checkout")} {...getModalProps("checkout")} />}
            {/* {isModalOpen("find") && <FindStuff handleClose={() => closeModal("find")} {...getModalProps("find")} />} */}
            {isModalOpen("editPreference") && <EditPreference handleClose={() => closeModal("editPreference")} {...getModalProps("editPreference")} />}
        </>
    );
};

export default ModalManager;
